module.exports = __webpack_public_path__ + "img/mi.a3472fd4.jpeg";